import { EventDataMessageType } from "@app/pippa/models";

export const shouldShowAvatarLogo = (
  messages: EventDataMessageType[],
  index?: number
): boolean => {
  if (index === undefined) {
    return true;
  }

  const currentMessage = messages[index];

  if (currentMessage.isSendByUser) {
    return false;
  }

  const isLastMessage = index === messages.length - 1;
  if (isLastMessage) {
    return true;
  }

  for (let i = index + 1; i < messages.length; i++) {
    const nextMessage = messages[i];

    if (nextMessage.isSendByUser) {
      return true;
    }

    if (!nextMessage.isSendByUser) {
      return false;
    }
  }

  return false;
};
